export function friendlyAuthError(message: string | undefined | null): string {
  if (!message) return 'Something went wrong. Please try again.';

  const m = message.toLowerCase();

  if (m.includes('invalid login credentials') || m.includes('invalid_credentials')) {
    return 'Email or password is incorrect.';
  }
  if (m.includes('user already registered') || m.includes('already registered')) {
    return 'An account with this email already exists.';
  }
  if (m.includes('email not confirmed')) {
    return 'Please confirm your email address before signing in.';
  }
  if (m.includes('password should be at least')) {
    return 'Password must be at least 6 characters.';
  }
  // M29 — password recovery errors.
  if (m.includes('new password should be different')) {
    return 'New password must be different from your current password.';
  }
  if (
    m.includes('token has expired') ||
    m.includes('invalid token') ||
    m.includes('jwt expired')
  ) {
    return 'Your reset link has expired. Request a new password reset.';
  }
  if (m.includes('auth session missing') || m.includes('session not found')) {
    return 'Your reset session is invalid or expired. Request a new password reset.';
  }
  if (m.includes('same password as the old')) {
    return 'New password must be different from your current password.';
  }
  if (m.includes('rate limit') || m.includes('too many requests')) {
    return 'Too many attempts. Please wait a moment and try again.';
  }
  if (m.includes('network') || m.includes('fetch')) {
    return 'Connection failed. Check your internet and try again.';
  }

  return 'Something went wrong. Please try again.';
}
